import React, {useEffect, useState, useMemo} from 'react';
import {Button, Checkbox, Form, Input, message, Spin} from 'antd';
import {LockOutlined} from "@ant-design/icons";
import parsePhoneNumber from 'libphonenumber-js';
import Masks from './../../../config/masks';
import {useMutation} from 'react-query';
import {SocialLoginBTNS} from "../social";
import Store from '../../../library/store';

import {VerificationCode, SignUpProfile } from "../../../api/profile";




export const SignUp = (props) => {

    const [form] = Form.useForm();
    const [isValidEmail, setValidEmail] = useState(false);
    const [isValidPhone, setValidPhone] = useState(false);
    const [ isLoading, setIsLoading ] = useState(false);


    const SignInMutation = useMutation(
        (data) => SignUpProfile(data),
        {
            onSuccess: (data) => {
                console.log(`[SignInMutation] `, data);
                Store.set('nashstore_token', data.token);
                message.success(`Регистрация прошла успешно. Вам на почту отправлена ссылка для подтверждения профиля.`);
                setIsLoading(true);
                setTimeout(() => {
                    window.location.href = '/';
                }, 2500);
            },
            onError: (e) => {
                console.error(`[VerificationMutation] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    );


    const onFinish = (props) => {
        SignInMutation.mutate(props);
    }

    // const onFieldsChange = (_, allFields) => {
    //     let email = allFields.filter(i => i.name.indexOf('email') + 1 > 0);
    //     setValidEmail(email && email.length > 0 && email[0].value && email[0].errors.length === 0);
    // }

    return (
        <div className={`component sign_in sign_up`}>
            <h2>Регистрация в платформе</h2>
            <div className="sign_in--wrp">
                <Spin spinning={isLoading}>
                    <Form
                        form={form}
                        layout={"vertical"}
                        name={`sign_up`}
                        onFinish={onFinish}
                        // onFieldsChange={onFieldsChange}
                        autoComplete="off"
                    >
                        <Form.Item
                            label={`Фамилия`}
                            name={`second_name`}
                            rules={[{required: true, message: `Укажите фамилию`}]}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            label={`Имя`}
                            name={`first_name`}
                            rules={[{required: true, message: `Укажите имя`}]}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            label={`Эл. почта`}
                            name={`email`}
                            rules={[
                                {required: true, message: 'Укажите ваш почтовый адрес'},
                                {type: 'email', message: 'Укажите корректный почтовый адрес'},
                            ]}
                        >
                            <Input
                                onChange={(e) => {
                                    let value = e.target.value.trim();
                                    form.setFieldsValue({email: value});
                                }}
                            />
                        </Form.Item>

                        <Form.Item
                            label={`Телефон`}
                            name={`phone`}
                            rules={[
                                {required: true, message: `Укажите номер телефона`},
                                {
                                    validator: async (_, phone = '') => {
                                        // const { short, phone, code } = names;
                                        const phoneNumber = parsePhoneNumber(`${phone}`);
                                        if (!phoneNumber || !phoneNumber.isValid()) {
                                            setValidPhone(false);
                                            return Promise.reject(new Error('Введен не корректный номер телефона'));
                                        } else {
                                            setValidPhone(phone !== '');
                                        }
                                    }
                                },
                            ]}
                        >
                            <Input placeholder={`Ваш номер, например +7999999999`} onChange={(e) => {
                                let value = e.target.value.trim();
                                form.setFieldsValue({phone: value});
                            }}/>
                        </Form.Item>

                        <Form.Item
                            label={`Пароль`}
                            name="password"
                            rules={[
                                {required: true, message: 'Укажите ваш пароль'}
                            ]}
                        >
                            <Input.Password
                                prefix={<LockOutlined/>}
                            />
                        </Form.Item>
                        <Form.Item
                            name={"terms"}
                            valuePropName="checked"
                            rules={[
                                {
                                    validator: (_, value) =>
                                        value ? Promise.resolve() : Promise.reject(new Error('Необходимо принять условия')),
                                },
                            ]}
                        >
                            <Checkbox>Я принимаю условия <a href={"/rules"} target={"_blank"}>оферты</a> и даю своё согласие на обработку моей персональной информации на условиях, определенных <a href={"/confidential"} target={"_blank"}>Политикой
                                    конфиденциальности</a>.</Checkbox>
                        </Form.Item>
                        <div className="sign_up--actions">
                            <Button type={`primary`} htmlType={`submit`} loading={SignInMutation.isLoading}>Продолжить</Button>
                        </div>
                    </Form>
                    <SocialLoginBTNS title={`Или зарегистрируйтесь с помощью`}/>
                </Spin>
            </div>
        </div>
    );
};

const CountDownTimer = ({label, name, messageValidate, timeLimit = 5, help = '', form}) => {

    const [countDownStart, setCountDownStart] = useState(false);
    const [codeSend, setCodeSend] = useState(false);
    const [ value, setValue ] = useState(false);

    const [timer, setTimer] = useState(0);
    let countDownInterval = 0;


    const VerificationMutation = useMutation(
        (data) => VerificationCode(data),
        {
            onSuccess: (data, vars) => {
                if (vars?.type === 'email') {
                    message.success(`На ваш email-адрес отправлен проверочный код`);
                }
                if (vars?.type === 'phone') {
                    message.success(`На ваш телефон скоро поступит звонок`);
                }
            },
            onError: (e) => {
                console.error(`[VerificationMutation] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
   )

    useEffect(() => {
        if (countDownStart === true) {
            if (timer - 1 <= 0) {
                setCountDownStart(false);
                setTimer(0);
            } else {
                countDownInterval = setTimeout(() => {
                    setTimer(timer - 1);
                }, 1000);
                return () => {
                    clearTimeout(countDownInterval);
                };
            }
        }
    }, [countDownStart, timer]);

    const sendCode = async (e) => {
        e.preventDefault();
        if (countDownStart === false) {
            await setTimer(timeLimit);
            await setCodeSend(true);
            await setCountDownStart(true);
            const FieldName = name === 'phone_code' ? 'phone' : 'email';
            const Value = form.getFieldValue(FieldName) || "";
            VerificationMutation.mutate({
                type: FieldName,
                value: Value
            });
        }
    }

    return (
        <Form.Item
            label={label}
            name={name}
            extra={codeSend ? help : ''}
            rules={[
                {required: true, message: messageValidate},
            ]}
        >
            <Input
                onChange={(e) => {
                    setValue(e.target.value.length >= 4);
                }}
                addonAfter={
                    countDownStart ?
                        <a href={'#'} onClick={sendCode}>{timer} сек.</a> :
                        value === false ? <a href={'#'} onClick={sendCode}>Получить код</a> : null
                }
            />
        </Form.Item>
    );
}


export default SignUp;